<div class="containers">
    <div class="inventory-tab-component">
        <div class="header header-with-variant">
            <div class="header-left">
                <div class="title">{{"inventory.inventory_tab.title" | translate}}</div>
                <span *ngIf="variants.length > 1 && variantControl.value === 'all_variants'" class="span"><img class="image" src="assets/icones/new-link-icon.svg" alt="">{{"inventory.inventory_tab.read_only" | translate}}</span>
            </div>
            <div *ngIf="variants && variants.length > 1" class="standard-input standard-input-variant">
                <mat-select [formControl]="variantControl">
                    <mat-option *ngFor="let variant of variants" [value]="variant.product_id">{{ variant.values.join(' / ') }}</mat-option>
                </mat-select>
            </div>
        </div>
        <ng-container *ngIf="product">
            <div class="stats-container" *appFieldVisible="{ module: 'product', field: 'stock' }">
                <!-- Products Quantity Requested Card -->
                <div class="stat-card">
                    <div class="stat-header">
                    <span class="stat-title">{{ "inventory.inventory_tab.stock_on_hand" | translate }}</span>
                    </div>
                    <span class="stat-value">{{ currentStockDetails.total_on_hand | number }}</span>
                </div>

                <!-- Products Reserved Quantity Requested Card -->
                <div class="stat-card">
                    <div class="stat-header">
                    <span class="stat-title">{{  "inventory.inventory_tab.stock_reserved" | translate }}</span>
                    </div>
                    <span class="stat-value">{{ currentStockDetails.total_reserved_stock | number }}</span>
                </div>

                <!-- Product Quantity Available Requested Card -->
                <div class="stat-card">
                    <div class="stat-header">
                    <span class="stat-title">{{  "inventory.inventory_tab.stock_available" | translate }}</span>
                    </div>
                    <span class="stat-value">{{ currentStockDetails.total_available_stock | number }}</span>
                    
                </div>
                
            </div>
        </ng-container>
        <div class="warehouses-list-container" *appFieldVisible="{ module: 'product', field: 'stock' }">
            <div class="warehouses-rows-wrapper">                
                <div class="warehouse-row header-bg">
                    <div class="col-cell">
                        <span class="header-title">{{"inventory.inventory_tab.warehouse.name" | translate}}</span>
                    </div>
                    <div class="col-cell">
                        <span class="header-title">{{"inventory.inventory_tab.warehouse.on_hand" | translate}}</span>
                    </div>
                    <div class="col-cell">
                        <span class="header-title">{{"inventory.inventory_tab.warehouse.available" | translate}}</span>
                    </div>
                </div>
                <ng-container *ngFor="let warehouse of getWarehouses()">
                    <div class="warehouse-row">
                        <div class="col-cell">
                            <div class="col-value">{{warehouse.name}}</div>
                        </div>
                        <div class="col-cell">
                            <div class="col-value">{{warehouse.quantity | number}}</div>
                        </div>
                        <div class="col-cell">
                            <div class="col-value">{{warehouse.available_quantity | number}}</div>
                        </div>
                    </div>
                </ng-container>
            </div>
        </div>
        <div class="default-warehouse-section" *ngIf="!(variants.length > 1 && variantControl.value === 'all_variants') && currentWarehouses && currentWarehouses.length > 0">
            <div class="header">
                <div class="header">
                    <div class="title-madium">{{"inventory.inventory_tab.warehouse.default" | translate}}</div>
                    <img 
                        class="image info-icon-clickable" 
                        width="20px" 
                        src="assets/icones/info-cc.svg" 
                        alt=""
                        [matTooltip]="'inventory.inventory_tab.warehouse.default_info_tooltip' | translate"
                        matTooltipPosition="right">
                </div>
            </div>
            <div class="handling-unit-select-wrapper">
                <mat-select *ngIf="defaultWarehouse" [(ngModel)]="defaultWarehouse" [disabled]="true">
                    <mat-select-trigger>
                        <span class="tag">{{ getWarehouseLabel(defaultWarehouse) }}</span>
                    </mat-select-trigger>
                    <mat-option *ngFor="let warehouse of getWarehouses()" [value]="warehouse.warehouse_id">
                         {{ warehouse.name }}
                    </mat-option>
                </mat-select>
            </div>
        </div>
        <div class="separator"></div>
        <div class="header">
            <div class="header-title">{{"inventory.packaging" | translate}}</div>
        </div>
        <div class="handling-units-list-container">
            <div class="header hu-packaging-heading">
                <div class="header">
                    <div class="title-madium">{{"inventory.inventory_tab.handling_units" | translate}}</div>
                    <img
                        class="image info-icon-clickable"
                        width="20px"
                        src="assets/icones/info-cc.svg"
                        alt=""
                        [matTooltip]="'inventory.inventory_tab.handling_unit.info_tooltip' | translate"
                        matTooltipPosition="right">
                </div>
                <span *ngIf="variants.length > 1 && variantControl.value === 'all_variants'" class="span"><img class="image" src="assets/icones/new-link-icon.svg" alt="">{{"inventory.inventory_tab.read_only" | translate}}</span>
            </div>

            <div class="hu-section" *ngIf="getErpHandlingUnits().length > 0">
                <div class="hu-section__head">
                    <div>
                        <div class="hu-section__title">{{"inventory.inventory_tab.handling_unit.section_erp_title" | translate}}</div>
                        <div class="hu-section__subtitle">{{"inventory.inventory_tab.handling_unit.section_erp_subtitle" | translate}}</div>
                    </div>
                </div>
                <div class="handling-units-rows-wrapper hu-section__table">
                    <div class="handling-unit-row header-bg">
                        <div class="col-cell">
                            <span class="header-title">{{"inventory.inventory_tab.handling_unit.handling_unit" | translate}}</span>
                        </div>
                        <div class="col-cell">
                            <span class="header-title">{{"inventory.inventory_tab.handling_unit.quantity" | translate}}</span>
                        </div>
                        <div class="col-cell">
                            <span class="header-title">{{"inventory.inventory_tab.handling_unit.dimenssions" | translate}}</span>
                            <span class="dimenssions">(L &times; W &times; H)</span>
                        </div>
                    </div>
                    <div class="handling-unit-row" *ngFor="let handling_unit of getErpHandlingUnits()">
                        <div class="col-cell">
                            <div class="col-value">{{handling_unit.name}}</div>
                        </div>
                        <div class="col-cell">
                            <div class="col-value">{{handling_unit.quantity}}</div>
                        </div>
                        <div class="col-cell">
                            <div class="col-value">{{handling_unit.dimenssion_string}}</div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="hu-section">
                <div class="hu-section__head hu-section__head--with-action">
                    <div>
                        <div class="hu-section__title">{{"inventory.inventory_tab.handling_unit.section_platform_title" | translate}}</div>
                        <div class="hu-section__subtitle">{{"inventory.inventory_tab.handling_unit.section_platform_subtitle" | translate}}</div>
                    </div>
                    <ng-container *appHasPermission="{ module: 'product', action: 'edit' }">
                        <button
                            *ngIf="allowHandlingUnitEdits()"
                            class="action-btn secondary-btn icon-btn edit-btn-primary"
                            type="button"
                            [attr.aria-label]="'inventory.inventory_tab.handling_unit.add_selling_unit_aria' | translate"
                            (click)="addHandlingUnits()"
                        >
                            <span class="icon">
                                <app-svg-icon svgIcon="plus-cc"></app-svg-icon>
                            </span>
                        </button>
                    </ng-container>
                </div>
                <div class="handling-units-rows-wrapper hu-section__table">
                    <div class="handling-unit-row header-bg">
                        <div class="col-cell">
                            <span class="header-title">{{"inventory.inventory_tab.handling_unit.handling_unit" | translate}}</span>
                        </div>
                        <div class="col-cell">
                            <span class="header-title">{{"inventory.inventory_tab.handling_unit.quantity" | translate}}</span>
                        </div>
                        <div class="col-cell">
                            <span class="header-title">{{"inventory.inventory_tab.handling_unit.dimenssions" | translate}}</span>
                            <span class="dimenssions">(L &times; W &times; H)</span>
                        </div>
                        <ng-container *appHasPermission="{ module: 'product', action: 'edit' }">
                            <ng-container *ngIf="product && !product.readonly && !(variants.length > 1 && variantControl.value === 'all_variants')">
                                <div class="col-cell col-cell--actions" *ngIf="allowHandlingUnitEdits()">
                                    <span class="header-title">{{"inventory.inventory_tab.handling_unit.actions" | translate}}</span>
                                </div>
                            </ng-container>
                        </ng-container>
                    </div>
                    <div class="handling-unit-row hu-row--muted" *ngIf="allowHandlingUnitEdits() && getPlatformHandlingUnits().length === 0">
                        <div class="col-cell hu-platform-empty">
                            <span class="col-value">{{"inventory.inventory_tab.handling_unit.platform_empty" | translate}}</span>
                        </div>
                    </div>
                    <div class="handling-unit-row" *ngFor="let handling_unit of getPlatformHandlingUnits()">
                        <div class="col-cell">
                            <div class="col-value">{{handling_unit.name}}</div>
                        </div>
                        <div class="col-cell">
                            <div class="col-value">{{handling_unit.quantity}}</div>
                        </div>
                        <div class="col-cell">
                            <div class="col-value">{{handling_unit.dimenssion_string}}</div>
                        </div>
                        <ng-container *appHasPermission="{ module: 'product', action: 'edit' }">
                            <ng-container *ngIf="product && !product.readonly && !(variants.length > 1 && variantControl.value === 'all_variants')">
                                <div class="col-cell col-cell--actions" *ngIf="allowHandlingUnitEdits()">
                                    <button
                                        type="button"
                                        class="hu-row-edit-btn"
                                        (click)="editHandlingUnit(handling_unit)"
                                        [attr.aria-label]="'inventory.inventory_tab.handling_unit.edit_row_aria' | translate"
                                    >
                                        <app-svg-icon svgIcon="pen-cc"></app-svg-icon>
                                    </button>
                                </div>
                            </ng-container>
                        </ng-container>
                    </div>
                </div>
            </div>
            <div class="default-handling-unit-section" *ngIf="!(variants.length > 1 && variantControl.value === 'all_variants') && currentHandlingUnits.length > 0">
                <div class="header">
                    <div class="header">
                        <div class="title-madium">{{"inventory.inventory_tab.handling_unit.default" | translate}}</div>
                        <img 
                            class="image info-icon-clickable"
                            width="20px"
                            src="assets/icones/info-cc.svg"
                            alt=""
                            [matTooltip]="'inventory.inventory_tab.handling_unit.default_info_tooltip' | translate"
                            matTooltipPosition="right">
                    </div>
                </div>
                <div class="handling-unit-select-wrapper">
                    <mat-select *ngIf="defaultHandlingUnit" [disabled]="(canEditProduct$ | async) === false" [(ngModel)]="defaultHandlingUnit" (ngModelChange)="onDefaultHandlingUnitChange($event)">
                        <mat-select-trigger>
                            <span class="tag">{{ getHandlingUnitLabel(defaultHandlingUnit) }}</span>
                        </mat-select-trigger>
                        <mat-option *ngFor="let handlingUnit of getHandlingUnits()" [value]="handlingUnit.id">
                             {{ handlingUnit.name }}
                        </mat-option>
                    </mat-select>
                </div>
            </div>
        </div>
    </div>
</div>
